module.exports = new __parcel__URL__("Lobby2.911659de.hdr").toString();